import StoreSettingsPage from './detail/StoreSettingsPage';
import ApiTokensTab from './detail/ApiTokensTab';

export default function StoreApiTokens() {
	return (
		<StoreSettingsPage title='Store - API Tokens'>
			{(store) => <ApiTokensTab storeId={store.storeId} />}
		</StoreSettingsPage>
	);
}
